import React from "react";
import { useState, useEffect, useCallback, useContext, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import { useHistory } from "react-router-dom";
import { FirebaseContext } from '../../FirebaseContext';

import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, setaucid, setisfirsttime } from "../../actions/index";
import { encode } from "base-64";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import { maxString, maxStringNew } from "../../Helpers/Helpers";
import NotFound from "../include/NotFound";
import { svg } from "../../constants/Images";
import BounceLoader from "react-spinners/ClipLoader";
import { BASE_PATH } from "../../constants/Global";
import { getDatabase, ref, remove, onValue, set, off, update } from "firebase/database";
// import firebase from 'firebase/app';/

function Myauction(match) {
  ////  console.log(match);
  const getteampageData = useSelector((state) => state.setteamlistData);
  const updtoken = useSelector((state) => state.updtoken);
  let firebaseRef = null;
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isActive, setActive] = useState(false);
  const [isfirstrender, setisfirstrender] = useState(true);
  const getpageData = useSelector((state) => state.setactlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const refresh = useSelector((state) => state.setRefresh);
  const [cid, setCid] = useState(loginuser["cid"]);
  const history = useHistory({ forceRefresh: true });
  const { upddata, userupddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);

  const previousUpddataRef = useRef(upddata);

  // //  console.log('MSC cid:'+cid);
  const fetchData = async () => {
    console.log('fetchData')
    console.log(loginuser);
    // localStorage.removeItem('auction_id')

    setActive(true);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "authorization": JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;
         console.log('my auc response..............');
         console.log(response);
        if (response.success == true) {
          let responsedata = response.data;
          responsedata.path=response.data.path;
          setData(responsedata);

          dispatch(actlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
    if (localStorage.getItem("isadel")) {
      history.push(BASE_PATH + 'auction-detail')
    }
  };
  const userfirechange = (datasnap) => {
    if (datasnap.type == '1' && datasnap.upd == '1') {
      var newdata = {
        "aname": datasnap.detail.aname,
        "acttype": datasnap.detail.acttype,
        "atm": datasnap.detail.atm,
        "logo": datasnap.detail.logo,
        "bidup": datasnap.detail.bidup,
        "dt": datasnap.detail.dt,
        "player": datasnap.detail.player,
        "totalpoint": datasnap.detail.totalpoint,
        "minbid": datasnap.detail.minbid,
        "minplayer": datasnap.detail.minplayer,
      }
      var responsedata = {}
      if (getpageData == 0) {
        var responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: [...newdata],
          },
        };
      } else {
        var responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: [newdata, ...getpageData.responsedata.list],
          },
        };
      }
      dispatch(actlistData(responsedata));
      setData(responsedata.responsedata)
    }
    if (datasnap.type == '1' && datasnap.upd == '3') {
      if (getpageData != 0) {
        const updateitem = data.list.filter((ele, ind) => {
          return ele.aid != datasnap.id;
        });
        data.list = updateitem;
        setData(data);
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));

      }
      console.log('delete fired');
      


    }

  }
  const firechange = (datasnap) => {
    // //  console.log(datasnap)
    if (datasnap.type == "1" && datasnap.upd == "2") {
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter(
          (ele, ind) => {
            if (ele.aid == datasnap.id) {
              // //  console.log()
              ele.logo = datasnap.detail.logo
              ele.type = datasnap.detail.type;
              ele.acttype = datasnap.detail.acttype;
              ele.dt = datasnap.detail.dt;
              ele.atm = datasnap.detail.atm;
              ele.aname = datasnap.detail.aname;
              ele.totalpoint = datasnap.detail.totalpoint;
              ele.unit = datasnap.detail.unit;
              ele.minbid = datasnap.detail.minbid;
              ele.bidup = datasnap.detail.bidup;
              ele.player = datasnap.detail.player;
              ele.minplayer = datasnap.detail.minplayer;
              ele.ses = datasnap.detail.ses;
            }
            return ele;
          }
        );
        localStorage.setItem("auction_name", datasnap.detail.aname);
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));

      }
    }
    if ((datasnap.type == "1" && datasnap.upd == "4")) {
      setData(getpageData.responsedata)
    }

    // if (datasnap.type == "1" && datasnap.upd == "3") {
    //   //  console.log("dele condition")
    //   if (getpageData != 0) {
    //     //  console.log("inside data condition")
    //     const updateitem = data.list.filter((ele, ind) => {
    //       return ele.aid != datasnap.id;
    //     });
    //     //  console.log(updateitem)
    //     data.list = updateitem;
    //     setData(data);
    //     let responsedata = {
    //       responsedata: {
    //         path: getpageData.responsedata.path,
    //         cid: cid,
    //         list: updateitem,
    //       },
    //     };
    //     dispatch(actlistData(responsedata));

    //   }


    // }


  }
  const setauction = (ai, an, tm, ty, crptyp) => {
    const db = getDatabase();

    set(ref(db, 'map/info/userauc/' + cid), ai);
    localStorage.setItem("auction_id", ai);
    localStorage.setItem("auction_type", ty);
    localStorage.setItem("auction_name", an);
    localStorage.setItem("auction_tm", tm);
    localStorage.setItem("crp_typ", 1);
    dispatch(setaucid(ai));


    // const db = getDatabase();
    // const getmydata = ref(db, 'map/info/' + ai);
    // return onValue(getmydata, (snapshot) => {
    //   const datasnap = snapshot.val()
    //   //  console.log("hhhhhh")
    //   if (snapshot.exists()) {
    //     //  console.log(datasnap)
    //     //  console.log("data changed")
    //     if (datasnap.token !== updtoken) {

    //       firechange(datasnap)
    //     }

    //   }
    // });

    // }, []);
  }




  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };
  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);
        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
          },
        };

        await DataService.deleteAuction({ aid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;

            if (response.success == true) {
              const db = getDatabase();

              set(ref(db, 'map/info/' + vl), { "type": "1", "upd": "3", 'id': vl, "detail": "", "tkn": updtoken });
              set(ref(db, 'map/info/user/' + cid), { "type": "1", "upd": "3", 'id': vl, "detail": "", "tkn": updtoken });

              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });
              const updateitem = data.list.filter((ele, ind) => {
                return ele.aid != vl;
              });
              data.list = updateitem;
              setData(data);
            } else {

              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }

            setActive(false);
          })
          .catch(() => {
            //  console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [data]
  );
  //   //  console.log("upddata")
  // //  console.log(upddata)
  var flag = "0"
  useEffect(() => {

    // previousUpddataRef.current = upddata;


    if (refresh == 1) {
      fetchData(0);
      localStorage.removeItem('auction_id')
    } else {
      if (getpageData == 0) {
        fetchData(0);
      } else {
        if (getpageData.responsedata.cid == cid) {
          setData(getpageData.responsedata);
        } else {
          let responsedata = getpageData.responsedata;
          responsedata.list = [];
          setData(responsedata);
          fetchData(0);
        }
      }
    }
    const db = getDatabase();

    off(ref(db, 'map/info/' + localStorage.getItem('aid')));

    window.scrollTo(0, 0);
  }, [refresh]);


  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "1") {
          dispatch(setisfirsttime(upddata));
        }

      }
    }
  }, [upddata]);
  useEffect(() => {

    if (userupddata !== null) {
      if (userupddata !== isfirsttime) {
        userfirechange(userupddata);
        if (userupddata.type == "1") {

          dispatch(setisfirsttime(userupddata));
        }

      }
    }
  }, [userupddata]);

  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        <div>
          <Navigationtitle data={match} />
          <div
            id="top-categories"
            className="top-cat-area default-padding bottom-less"
          >
            <div className="container-fluid padding-left-0px">
              <section className="event-area">
                {/* <div className="container-fluid"> */}
                <div className="row">
                  {/* <p>{upddata && upddata.type}</p> */}
                  {data != "" ? (
                    data.list?.map((dt, key) => {
                      // //  console.log("aucdata")
                      // //  console.log(dt)
                      var isRunningStatus = dt.status == 3 || dt.status == 6;
                      var stcls = 'my-acution-top-top-relative';
                      var mylblstyle = {

                        background: 'white',
                      }
                      if (dt.status == 1) {

                        stcls += ' Sblue';
                      }
                      else if (dt.status == 3) {

                        stcls += ' Syellow';
                      }
                      else if (dt.status == 6) {

                        stcls += ' Syellow';
                      }
                      else if (dt.status == 5) {

                        stcls += ' Sgreen';
                      } else {

                        stcls += ' Sred';
                      }


                      return (
                        <div key={dt.aid} className="my-acution-card-container col-md-4 col-lg-4 width-100per">
                          <Link
                            title={dt.aname}
                            onClick={() => setauction(dt.aid, dt.aname, dt.atm, dt.acttype, dt.crp_typ)}
                            to="/auction-detail"
                          >
                            <div className="my-acution-top-box-shadow">
                              <div className="my-acution-top-top">
                                <div className="my-acution-top-top-text">
                                  A Code : {dt.acode}
                                </div>
                                <div className={stcls} style={isRunningStatus ? {
                                  animation: 'auctionStatusPulse 1.5s ease-in-out infinite',
                                  transformOrigin: 'center',
                                } : {}} onClick={(e) => {
                                  if (dt.status == 6 && dt.status == 2 && dt.status == 0) {

                                    e.preventDefault()
                                    history.push(BASE_PATH + 'auction-payment')
                                  }
                                }}>
                                  {dt.status == 1 ? svg.label2 : dt.status == 3 || dt.status == 6 ? svg.label4 : dt.status == 5 ? svg.label3 : svg.label}

                                  <div className="my-acution-top-top-absolute" style={{fontWeight: '900'}} >
                                    {dt.status == 1 ? "ACTIVE" : dt.status == 3 || dt.status == 6 ? "RUNING" : dt.status == 5 ? "COMPLETED" : "DEACTIVE"}
                                  </div>
                                </div>
                              </div>
                              <div className="my-acution-top-bottom">
                                <div className="my-acution-top-bottom-logo">
                                  {" "}
                                  {/* <Image
                                      fallback={
                                        <Shimmer
                                          className="shimmer"
                                          width={50}
                                          height={50}
                                        />
                                      }
                                      src={
                                        dt.logo == ""
                                          ? auctiondefaultLogo
                                          : data.path + dt.logo
                                      }
                                    ></Image> */}
                                  <img
                                    src={
                                      dt.logo == ""
                                        ? auctiondefaultLogo
                                        : data.path + dt.logo
                                    }
                                    alt="logo"
                                  // style={{ height: "50px" }}
                                  />
                                </div>
                                <div className="my-acution-top-bottom-content">
                                  <div className="my-acution-top-bottom-content-text">
                                    {" "}

                                    {maxStringNew(dt.aname)}

                                  </div>
                                  <div>
                                    {" "}
                                    <h5>
                                      {" "}
                                      <AiIcons.AiOutlineCalendar
                                        style={{
                                          fontSize: "16px",
                                          top: 3,
                                          position: "relative",
                                          color: "#186CC2",
                                        }}
                                      />{" "}
                                      {dateFormat(dt.dt, "d mmm, yyyy")} &nbsp; {dt.atm}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                          <div className="my-acution-bottom row">
                            <div className="col-md-6 my-acution-bottom-text">
                              {" "}
                              Point <span> {dt.totalpoint} </span>
                            </div>
                            <div className="col-md-6 my-acution-bottom-text">
                              {" "}
                              Base Bid <span>{dt.minbid} </span>
                            </div>
                            <div className="col-md-6 my-acution-bottom-text">
                              {" "}
                              Bid Incr <span>{dt.bidup} </span>
                            </div>
                            <div className="col-md-6 my-acution-bottom-text">
                              {" "}
                              <span>
                                <AiIcons.AiOutlineTeam
                                  style={{
                                    fontSize: "17px",
                                    top: 3,
                                    position: "relative",
                                    color: "#186CC2",
                                  }}
                                />{" "}
                                {dt.player}
                                /Team{" "}
                              </span>
                            </div>
                            <div className="col-md-12 text-align aucbottom" style={{ 'display': 'flex' }}>
                              <div className="lbl1" >

                                <Link onClick={() => setauction(dt.aid, dt.aname, dt.atm, dt.acttype, dt.crp_typ)} title="Teams" to="/auction-team"> {svg.team1}</Link>
                                <Link onClick={() => setauction(dt.aid, dt.aname, dt.atm, dt.acttype, dt.crp_typ)} title="Category" to="/auction-category"> {svg.category2}</Link>
                                <Link onClick={() => setauction(dt.aid, dt.aname, dt.atm, dt.acttype, dt.crp_typ)} title="Players" to="/auction-players"> {svg.players2}</Link>
                              </div>
                              <div className="lbl2">
                                <Link
                                  title={dt.aname}
                                  onClick={() => setauction(dt.aid, dt.aname, dt.atm, dt.acttype, dt.crp_typ)}
                                  to="/auction-detail"
                                  style={{ color: "#186CC2" }}
                                >
                                  <AiIcons.AiOutlineInfoCircle size={"20px"} />
                                </Link>
                                <Link
                                  style={{
                                    color: "#186cc2",
                                    padding: "0 18px",
                                  }}
                                  onClick={() => setauction(dt.aid, dt.aname, dt.atm, dt.acttype, dt.crp_typ)}
                                  to={"/edit-auction/" + encode(dt.aid)}
                                >
                                  <AiIcons.AiOutlineEdit
                                    size={"20px"}
                                    style={{ color: "green" }}
                                  />
                                </Link>
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    deldata(dt.aid);
                                  }}
                                  style={{ color: "red", cursor: "pointer" }}
                                >
                                  <AiIcons.AiOutlineDelete size={"20px"} />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <NotFound data={isActive} />
                  )}
                </div>
                {/* </div> */}
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Myauction;
